var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8089 0.152669C12.0478 0.370401 12.0651 0.740634 11.8473 0.979608L4.76434 8.75362L0.168152 4.08329C-0.0586117 3.85287 -0.0556467 3.48225 0.174774 3.25549C0.405195 3.02872 0.775816 3.03169 1.00258 3.26211L4.73159 7.05126L10.9819 0.191132C11.1997 -0.047842 11.5699 -0.0650621 11.8089 0.152669Z",
    fill: "#0049C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedIcon);
export default __webpack_public_path__ + "static/media/selected_icon.ed88b75f88860812a52f16c4e87a4075.svg";
export { ForwardRef as ReactComponent };